const copyButton = document.querySelector("[data-copy-code]");
const code = document.querySelector("[data-code]");

if (copyButton && code) {
  copyButton.addEventListener("click", async () => {
    const original = copyButton.textContent;
    try {
      await navigator.clipboard.writeText(code.textContent.trim());
      copyButton.textContent = "Copied";
    } catch {
      copyButton.textContent = "Select";
    }
    window.setTimeout(() => {
      copyButton.textContent = original;
    }, 1400);
  });
}

const header = document.querySelector("[data-header]");
const setHeaderState = () => {
  if (!header) return;
  header.classList.toggle("is-scrolled", window.scrollY > 8);
};

setHeaderState();
window.addEventListener("scroll", setHeaderState, { passive: true });
